module.exports = __webpack_public_path__ + "img/JAOC_POP_WhiteSauce_square.1c452aa5.png";